// Filter actions
export const SET_SEARCH_QUERY = 'search/SET_QUERY';
export const SET_ASSIGNEE = 'search/SET_ASSIGNEE';
export const SET_AUTHOR = 'search/SET_AUTHOR';
export const SET_SELECTED_TAGS = 'search/SET_SELECTED_TAGS';
export const TOGGLE_TAG = 'search/TOGGLE_TAG';
export const SET_TAG_METHOD = 'search/SET_TAG_METHOD';
export const SET_BOOKMARKED_ONLY = 'search/SET_BOOKMARKED_ONLY';
export const SET_ANCESTOR_ID = 'search/SET_ANCESTOR_ID';
export const SET_STATUS_FILTER = 'search/SET_STATUS_FILTER';
export const SET_CHANNEL_IDS = 'search/SET_CHANNEL_IDS';
export const TOGGLE_CHANNEL_ID = 'search/TOGGLE_CHANNEL_ID';
export const TOGGLE_GROUP_CHANNELS = 'search/TOGGLE_GROUP_CHANNELS';
export const CLEAR_CHANNEL_IDS = 'search/CLEAR_CHANNEL_IDS';
export const SET_MEDIA_TYPE_FILTER = 'search/SET_MEDIA_TYPE_FILTER';
export const SET_SENT_BY_FILTER = 'search/SET_SENT_BY_FILTER';
export const SET_SENT_TO_FILTER = 'search/SET_SENT_TO_FILTER';
export const SET_DATE_RANGE_FILTER = 'search/SET_DATE_RANGE_FILTER';
export const CLEAR_ALL_FILTERS = 'search/CLEAR_ALL_FILTERS';

// Applied filters tracking
export const SET_APPLIED_FILTERS = 'search/SET_APPLIED_FILTERS';

// Results actions
export const SET_SEARCH_RESULTS = 'search/SET_RESULTS';
export const UPDATE_FOLDER = 'search/UPDATE_FOLDER';
export const DELETE_FOLDER = 'search/DELETE_FOLDER';
export const UPDATE_LINK = 'search/UPDATE_LINK';
export const DELETE_LINK = 'search/DELETE_LINK';
export const SET_ANCESTOR_INFO = 'search/SET_ANCESTOR_INFO';

// Reference data actions
export const SET_USERS = 'search/SET_USERS';
export const SET_TAGS = 'search/SET_TAGS';
export const SET_RECENT_TAGS = 'search/SET_RECENT_TAGS';

// Loading states
export const SET_SEARCH_LOADING = 'search/SET_LOADING';
export const SET_FETCHING_NEW_DATA = 'search/SET_FETCHING_NEW_DATA';

// UI state actions
export const SET_VIEW_MODE = 'search/SET_VIEW_MODE';
export const SET_ACTIVE_TAB = 'search/SET_ACTIVE_TAB';
export const SET_PAGE_SIZE = 'search/SET_PAGE_SIZE';
export const SET_PAGE = 'search/SET_PAGE';
export const SET_FOLDERS_PAGE = 'search/SET_FOLDERS_PAGE';
export const SET_LINKS_PAGE = 'search/SET_LINKS_PAGE';
export const SET_MESSAGES_PAGE = 'search/SET_MESSAGES_PAGE';

// Initialization
export const SET_INITIALIZED = 'search/SET_INITIALIZED';

